import React, { useState, useRef, useEffect, useContext, useMemo, useCallback } from "react";
import axios from "axios";
import config from "../../config";
import QuestContext from "../QuestWrapper";
import Pointer from "../../assets/images/pointer.svg";
import XP from "../../assets/images/xp.svg";
import './spinTheWheel.css';
import Shadow from '../../assets/images/Shadow.png';
import General, { hexToGlassColor, useGeneral } from "../../general";
import Loader from "./Loader";
import Coin from '../../assets/images/coin-icon.svg';
interface SpinTheWheelProps {
  userId?: string;
  token?: string;
  uniqueUserId?: string,
  uniqueEmailId?: string,
  questId?: string;
  criteriaId?: string;
  campaignId?: string;
  actionId?: string;
  campaignVariationId?: string;
  maxSpins?: number;
  rewards?: RewardData[];
  wheelColors?: {
    primary: string;
    secondary: string;
  };
  isAccumulateXP?: boolean;
  wheelImage?: string;
  winningIndex?: number;
  onSpinComplete?: () => void;
  successCall?: () => void;
  isImgShow?: boolean;
  styleConfig?: {
    claimButtonStyle?: React.CSSProperties;
    wheelContainerStyle?: React.CSSProperties;
    wheelImageStyle?: React.CSSProperties;
    successModalStyle?: React.CSSProperties;
    segmentContentStyle?: React.CSSProperties;
  };
  claimButtonText?: string;
  wheelTextColor?: {
    primary: string;
    secondary: string;
  };
  winningSegmentColor?: string;
  spinText?: {
    text?: string;
    style?: React.CSSProperties;
  },
  spinCenteredText?: string;
  isSecondaryImage?: boolean;
  onGuestUserClick?: () => void;
  onCompletedCriteriaUserClick?: () => void;
  isClaimTitle?: boolean;
  isLoader?: boolean;
  isPoint?: boolean;
  loaderComponent?: React.ReactNode;
  isV1API?: boolean;
  variation?: string;
  entityAuthenticationToken?: string;
  brandTheme?: any;
  questThemeData?: any;
  wheelWidth?: number;
}

interface RewardData {
  title: string;
  value: string;
  image?: string;
}

const SpinTheWheel: React.FC<SpinTheWheelProps> = ({
  maxSpins = 1,
  rewards,
  wheelColors,
  wheelImage,
  winningIndex,
  userId,
  token,
  uniqueEmailId,
  uniqueUserId,
  questId,
  criteriaId,
  campaignId,
  campaignVariationId,
  actionId,
  onSpinComplete,
  successCall,
  isAccumulateXP = false,
  isImgShow,
  styleConfig,
  claimButtonText,
  wheelTextColor,
  winningSegmentColor,
  spinText,
  spinCenteredText,
  isSecondaryImage,
  onGuestUserClick,
  onCompletedCriteriaUserClick,
  isClaimTitle,
  isLoader,
  isPoint,
  loaderComponent,
  isV1API = false,
  variation = "default",
  entityAuthenticationToken,
  brandTheme,
  questThemeData,
  wheelWidth
}) => {
  const { apiKey, apiSecret, entityId, apiType, user } = useContext(QuestContext.Context);
  const [spinCount, setSpinCount] = useState<number>(0);
  const wheelRef = useRef<HTMLDivElement>(null);
  const [rotationAngle, setRotationAngle] = useState<number>(0);
  const [isSpinning, setIsSpinning] = useState<boolean>(false);
  const [rewardImage, setRewardImage] = useState<string>(isPoint ? Coin : XP);
  const [rewardValue, setRewardValue] = useState<string>("1");
  const [rewardSecondaryImage, setRewardSecondaryImage] = useState<string>('');
  const [winningSegmentIndex, setWinningSegmentIndex] = useState<number | null>(
    null
  );
  let BACKEND_URL = apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL
  let GeneralFunctions = new General("");

  const [showCongratulations, setShowCongratulations] = useState(false);
  const [isText, setIsText] = useState(true);
  const [Rewards, setRewards] = useState<RewardData[] | any[]>(rewards || Array(10).fill({ title: '' }));
  const [isCriteriaCompleted, setIsCriteriaCompleted] = useState<boolean | null>(null);
  const [questUserId, setQuestUserId] = useState(userId);
  const [questToken, setQuestToken] = useState(token);

  const [isLoaded, setIsLoaded] = useState(false);
  const [actions, setActions] = useState([]);
  const [questDetails, setQuestDetails] = useState<any>(null);

  const [newCampaignVariationId, setNewCampaignVariationId] = useState(campaignVariationId);
  const [newActionId, setNewActionId] = useState(actionId);

  const [BrandTheme, setBrandTheme] = useState(brandTheme);
  const [QuestThemeData, setQuestThemeData] = useState(questThemeData);

  const general = useGeneral('quest')

  const fetchRewards = async () => {
    try {
      const headers = {
        apiKey: apiKey,
        apisecret: apiSecret,
        userId: questUserId,
        token: questToken,
        userid: questUserId,
      };

      const params = new URLSearchParams();
      params.set("platform", "REACT");
      if (variation) params.set("variation", variation);

      const request = (isV1API === false || isV1API === undefined)
        ? `${BACKEND_URL}api/v2/entities/${entityId}/campaigns/${questId || campaignId}?${params.toString()}`
        : `${BACKEND_URL}api/entities/${entityId}/quests/${questId}`

      const response = await axios.get(request, { headers });

      let questDetails = (isV1API === false || isV1API === undefined) ? response.data.data : response.data;
      setQuestDetails(questDetails);
      if (isV1API === false || isV1API === undefined) {
        setActions((prev) => prev = questDetails.actions);
        newCampaignVariationId === undefined && setNewCampaignVariationId((prev) => prev = questDetails?.campaignVariationId);
        newActionId === undefined && setNewActionId((prev) => prev = questDetails?.actions[0]?.actionId);
      }
      if (questDetails?.sdkConfig?.uiProps?.BrandTheme) {
        setBrandTheme(questDetails?.sdkConfig?.uiProps?.BrandTheme?.properties);
      }
      if (questDetails?.sdkConfig?.uiProps?.questThemeData) {
        setQuestThemeData(questDetails?.sdkConfig?.uiProps?.questThemeData);
      }
      if ((isV1API === false || isV1API === undefined) &&
        (questDetails.actions[0]?.actionType !== 'SPIN_THE_WHEEL' ||
          // questDetails?.actions[0]?.actionId !== actionId ||
          (questDetails?.actions[0]?.completed === true))
      ) {
        setIsCriteriaCompleted(true);
      } else if ((isV1API == true) &&
      (questDetails.eligibilityData?.length !== 1 ||
        questDetails.eligibilityData[0]?.data?.criteriaType !== 'SPIN_THE_WHEEL' ||
        questDetails?.eligibilityData[0]?.data?.criteriaId !== criteriaId ||
        questDetails?.eligibilityData[0]?.completed !== false)
      ) {
        setIsCriteriaCompleted(true);
      }

      const validatedRewards = questDetails.rewards?.slice(0, 10);

      let rewardsDetails = validatedRewards?.map((el: any) => {
        const isRewardXP = el?.rewardType === 'REWARD_XP';
        return {
          title: isRewardXP
            ? isPoint
              ? 'Points'
              : 'XP'
            : el?.metadata?.name || el?.metadata?.title,
          value: isRewardXP ? (el?.metadata?.xp || el?.xp) : el?.metadata?.gemsData,
          image: isRewardXP
            ? isPoint
              ? Coin
              : XP
            : el?.metadata?.logo || el?.metadata?.imageURL,
          rewardType: el?.rewardType,
        };
      });
      setRewards(rewardsDetails);
    } catch (error) {
      GeneralFunctions.captureSentryException(error);
    } finally {
      setIsLoaded(true);
    }
  };

  const checkSpinTheWheel = () => {
    const headers = {
      apiKey: apiKey,
      apisecret: apiSecret,
      userId: questUserId,
      token: questToken,
      userid: questUserId,
    };

    let request = (isV1API === false || isV1API === undefined)
      ? `${BACKEND_URL}api/v2/entities/${entityId}/actions/${newActionId}/check-action-status?campaignVariationId=${newCampaignVariationId}&isSpinTheWheel=${true}`
      : `${BACKEND_URL}api/entities/${entityId}/quests/${questId}/get-verify-status?userId=${questUserId}&criteriaId=${criteriaId}`

    axios
      .get(request, { headers: headers })
      .then((res) => {
        var response = res.data;
        if ((isV1API === false || isV1API === undefined) && response?.success && !response?.proceed && response?.message) {
          setIsCriteriaCompleted(true);
        } else if (isV1API == true && response == false) {
          setIsCriteriaCompleted(true);
        } else {
          setIsCriteriaCompleted(false);
        }
      })
      .catch((error) => {
        GeneralFunctions.captureSentryException(error);
        console.log("Error:", error);
      })
  };

  useEffect(() => {
    if (userId || questUserId) {
      if (Rewards[0]?.title === '') {
        fetchRewards();
      }

      if ((isV1API === false || isV1API === undefined) && newCampaignVariationId && newActionId) {
        checkSpinTheWheel();
      } else if (isV1API == true) {
        checkSpinTheWheel();
      }
    }

    if (uniqueEmailId || uniqueUserId) {
      getUserAuth();
    }
  }, [userId, questUserId, uniqueEmailId, uniqueUserId, newCampaignVariationId, newActionId]);


  const getUserAuth = async () => {
    let updatedUserId = questUserId;
    let updatedToken = questToken;
    try {

      const response = await GeneralFunctions.getExternalLogin({
        uniqueEmailId: uniqueEmailId || '',
        uniqueUserId: uniqueUserId || '',
        entityId,
        apiKey,
        apiSecret: "",
        token: questToken || '',
        userId: questUserId || '',
        entityAuthenticationToken: entityAuthenticationToken || "",
        apiType,
      });

      if (response?.userId) {
        updatedUserId = response.userId;
        updatedToken = response.token;
        setQuestUserId(updatedUserId);
        setQuestToken(updatedToken);
      }
    } catch (error) {
      GeneralFunctions.captureSentryException(error);
      console.log(error)
    }
  }

  const handleSpinClick = async () => {
    if (isCriteriaCompleted === null) return;
    if (questUserId === 'u-0000000000') {
      onGuestUserClick && onGuestUserClick();
      return;
    }
    if (isCriteriaCompleted) {
      onCompletedCriteriaUserClick && onCompletedCriteriaUserClick();
      return;
    }
    if (
      wheelRef.current &&
      !isSpinning &&
      maxSpins &&
      spinCount < maxSpins &&
      !showCongratulations &&
      Rewards[0]?.title !== ''
    ) {
      setIsSpinning(true);
      setIsText(false);
      wheelRef.current.style.transition = "transform 0s";
      wheelRef.current.style.transform = `rotate(0deg)`;

      wheelRef.current.offsetHeight;

      wheelRef.current.style.transition = "transform 3s ease-out";
      wheelRef.current.style.transform = `rotate(2160deg)`;

      general.trackEvent(
        'quest-spin-the-wheel-click',
        (uniqueUserId || userId || user.userId)!,
        { campaignId: questId || campaignId },
        true,
        !uniqueUserId
      )

      try {
        const apiResponse = await getRandomReward();

        const winningIndex = apiResponse.winningIndex;
        const reward = apiResponse.reward;

        if (reward?.length > 0) {
          const image =
            reward[0]?.metadata?.logo ||
            reward[0]?.metadata?.imageURL ||
            (isPoint ? Coin : XP);
          setRewardImage(image);

          const val = (reward[0]?.metadata?.xp || reward[0]?.xp)
            ? `+${reward[0]?.metadata?.xp || reward[0]?.xp} ${isPoint ? 'Points' : 'XP'}`
            : reward[0]?.metadata?.gemsData
              ? `+${reward[0]?.metadata?.gemsData} ${isClaimTitle
                ? reward[0]?.metadata?.claimTitle || reward[0]?.metadata?.name
                : reward[0]?.metadata?.name
              }`
              : `${isClaimTitle
                ? reward[0]?.metadata?.claimTitle || reward[0]?.metadata?.title
                : reward[0]?.metadata?.title
              }`;
          setRewardValue(val);

          const secondaryImage = reward[0]?.metadata?.secondaryImageURL || '';
          setRewardSecondaryImage(secondaryImage);
        }

        if (winningIndex == null || winningIndex == undefined) {
          console.error(
            "API response issue - winningIndex is null or already claimed reward"
          );
          setIsSpinning(false);
          setRotationAngle(0);
          if (onSpinComplete) {
            onSpinComplete();
          }
          setSpinCount((prevSpinCount) => prevSpinCount + 1);
          setIsText(true);
          return;
        }

        const segmentAngle = 360 / Rewards.length;
        const segmentMiddleOffset = segmentAngle / 2;
        const stopAngle = 360 * 4 + segmentAngle * winningIndex + segmentMiddleOffset;
        setRotationAngle(stopAngle);

        wheelRef.current.style.transition = "transform 3s cubic-bezier(0.17, 0.67, 0.12, 0.99)";
        wheelRef.current.style.transform = `rotate(${stopAngle}deg)`;

        setTimeout(() => {
          if (wheelRef.current) {
            wheelRef.current.style.transition = "";
            setIsSpinning(false);
            setSpinCount((prevSpinCount) => prevSpinCount + 1);
            setRotationAngle(0);
            setWinningSegmentIndex(winningIndex);

            setTimeout(() => {
              setShowCongratulations(true);
              setIsSpinning(false);
              if (onSpinComplete) {
                onSpinComplete();
              }
            }, 1500);
          }
        }, 1000);
      } catch (error) {
        console.error("API call failed", error);
        GeneralFunctions.captureSentryException(error);
        setIsSpinning(false);
        setRotationAngle(0);
      }
    }
  };

  const getRandomReward = async (): Promise<{
    winningIndex: number | null;
    reward: any;
  }> => {
    try {
      const headers = {
        apiKey: apiKey,
        apisecret: apiSecret,
        userId: questUserId,
        token: questToken,
        userid: questUserId,
      };

      let json = (isV1API === false || isV1API === undefined) ? {
        actionId: newActionId,
        campaignVariationId: newCampaignVariationId,
        actions
      } :
        {
          criteriaId: criteriaId,
          isAccumulateAndSelf: isAccumulateXP,
        }

      let request = (isV1API === false || isV1API === undefined)
        ? `${BACKEND_URL}api/v2/entities/${entityId}/campaigns/${questId || campaignId}/verify?autoClaim=true`
        : `${BACKEND_URL}api/entities/${entityId}/quests/${questId}/verify?userId=${questUserId}`

      const response = await axios.post(request, json, { headers: headers });

      if (response.data.success) {
        return {
          winningIndex: response.data.winningIndex,
          reward: response.data.reward,
        };
      } else {
        return { winningIndex: null, reward: "" };
      }
    } catch (error) {
      GeneralFunctions.captureSentryException(error);
      console.error("Error:", error);
      return { winningIndex: null, reward: "" };
    }
  };


  useEffect(() => {
    general.trackEvent(
      'quest-spin-the-wheel-loaded',
      (uniqueUserId || userId || user.userId)!,
      { campaignId: questId || campaignId },
      true,
      !uniqueUserId,
      true
    )
    return () => {
      setIsSpinning(false);
      setRotationAngle(0);
    };
  }, []);

  const segmentCount = Rewards?.length || 0;
  const segmentAngle = segmentCount > 0 ? 360 / segmentCount : 0;
  const wheelSize = wheelWidth || 240;
  const radius = wheelSize / 2;

  const createSegmentPath = useCallback((index: number) => {
    const startAngle = (index * segmentAngle - 90) * (Math.PI / 180);
    const endAngle = ((index + 1) * segmentAngle - 90) * (Math.PI / 180);

    const x1 = radius + radius * Math.cos(startAngle);
    const y1 = radius + radius * Math.sin(startAngle);
    const x2 = radius + radius * Math.cos(endAngle);
    const y2 = radius + radius * Math.sin(endAngle);

    const largeArc = segmentAngle > 180 ? 1 : 0;

    return `M ${radius} ${radius} L ${x1} ${y1} A ${radius * 0.9} ${radius * 0.9} 0 ${largeArc} 1 ${x2} ${y2} Z`;
  }, [segmentAngle, radius, wheelSize]);

  const getTextPosition = useCallback((index: number) => {
    const angle = (index * segmentAngle + segmentAngle / 2 - 90) * (Math.PI / 180);
    const textRadius = radius * 0.85;
    return {
      x: radius + textRadius * Math.cos(angle),
      y: radius + textRadius * Math.sin(angle),
      rotation: index * segmentAngle + segmentAngle / 2
    };
  }, [segmentAngle, radius, wheelSize]);

  const getImageSize = useMemo(() => {
    const baseSize = wheelSize / 15;
    if (segmentCount <= 4) return baseSize * 1.2;
    if (segmentCount <= 8) return baseSize;
    if (segmentCount <= 12) return baseSize * 0.8;
    if (segmentCount <= 16) return baseSize * 0.6;
    return baseSize * 0.5;
  }, [segmentCount, wheelSize]);

  const getFontSize = useMemo(() => {
    const baseSize = wheelSize / 30;
    if (segmentCount <= 4) return baseSize * 1.2;
    if (segmentCount <= 8) return baseSize;
    if (segmentCount <= 12) return baseSize * 0.8;
    if (segmentCount <= 16) return baseSize * 0.6;
    return baseSize * 0.5;
  }, [segmentCount, wheelSize]);

  const wrapText = (text: string, maxCharsPerLine: number): string[] => {
    const words = text.split(' ');
    const lines: string[] = [];
    let line = '';

    for (const word of words) {
      if ((line + (line ? ' ' : '') + word).length <= maxCharsPerLine) {
        line += (line ? ' ' : '') + word;
      } else {
        lines.push(line);
        line = word;

        if (lines.length === 2) {
          break;
        }
      }
    }

    if (lines.length < 3 && line) {
      lines.push(line);
    }

    if (lines.length === 3 && words.length > 0) {
      const lastLine = lines[2];
      if (lastLine.length + 3 <= maxCharsPerLine) {
        lines[2] = lastLine + '...';
      } else {
        lines[2] = lastLine.slice(0, maxCharsPerLine - 3).trimEnd() + '...';
      }
    }

    return lines;
  };

  return (
    <>
      {isLoaded ? <div className="mainContSpinWheel">
        <div className={'spinMainContainerStyle'} style={{ background: styleConfig?.wheelContainerStyle?.background || '#969696', ...styleConfig?.wheelContainerStyle }}>
          <div
            style={{
              filter: showCongratulations ? styleConfig?.successModalStyle?.filter || "blur(8.571428298950195px)" : "none"
            }}
            onClick={handleSpinClick}
          >
            <div className={'spinContainerStyle'} ref={wheelRef} style={{
              cursor: isSpinning ? "no-drop" : "pointer",
              position: 'relative',
              width: wheelSize,
              height: wheelSize,
            }}>
              <img src={Shadow} alt="" className="shadowImg" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 2,
                userSelect: "none"
              }} />

              <svg
                width={wheelSize}
                height={wheelSize}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 1
                }}
              >
                {Rewards.map((reward, index) => {
                  let segmentColor, textColor;

                  if (segmentCount % 2 === 0) {
                    segmentColor = index % 2 === 0
                      ? wheelColors?.primary || BrandTheme?.primaryColor || QuestThemeData?.accentColor || '#FF6B6B'
                      : wheelColors?.secondary || hexToGlassColor(BrandTheme?.primaryColor || QuestThemeData?.accentColor || '#FF6B6B', 0.3) || '#4ECDC4';

                    textColor = index % 2 === 0
                      ? wheelTextColor?.primary || BrandTheme?.titleColor || '#FFFFFF'
                      : wheelTextColor?.secondary || BrandTheme?.titleColor || '#FFFFFF';
                  } else {
                    const baseColor = wheelColors?.primary || BrandTheme?.primaryColor || QuestThemeData?.accentColor || '#FF6B6B';
                    const colorPattern = index % 3;

                    if (colorPattern === 0) {
                      segmentColor = baseColor;
                    } else if (colorPattern === 1) {
                      segmentColor = wheelColors?.secondary || hexToGlassColor(baseColor, 0.7) || '#4ECDC4';
                    } else {
                      segmentColor = hexToGlassColor(baseColor, 0.5) || '#96CEB4';
                    }

                    textColor = wheelTextColor?.primary || BrandTheme?.titleColor || '#FFFFFF';
                  }

                  const isWinningSegment = winningSegmentIndex !== null && (Rewards?.length - 1 - winningSegmentIndex) === index;

                  const lines = wrapText(`${Rewards[Rewards.length - index - 1]?.value || ""} ${Rewards[Rewards.length - index - 1]?.title || ""}`, 10);

                  return (
                    <g key={index}>
                      <path
                        d={createSegmentPath(index)}
                        fill={isWinningSegment ? (winningSegmentColor || "#FFDD7CBF") : segmentColor}
                        stroke="#FFF"
                        strokeWidth="1"
                        style={styleConfig?.segmentContentStyle}
                      />

                      {isImgShow && Rewards[Rewards.length - index - 1]?.image && (
                        <image
                          x={getTextPosition(index).x - getImageSize}
                          y={getTextPosition(index).y - getImageSize / 2}
                          width={getImageSize * 2 + 1}
                          height={getImageSize * 1.2}
                          href={Rewards[Rewards.length - index - 1].image}
                          transform={`rotate(${getTextPosition(index).rotation}, ${getTextPosition(index).x}, ${getTextPosition(index).y})`}
                        />
                      )}

                      <text
                        x={getTextPosition(index).x - getImageSize * 1}
                        y={lines.length > 1 ? getTextPosition(index).y - getImageSize / 2 : getTextPosition(index).y + 2}
                        fill={textColor}
                        fontSize={getFontSize + 1}
                        fontWeight="bold"
                        fontFamily="Figtree"
                        textAnchor="end"
                        style={{ maxWidth: `${getImageSize * 3}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        dominantBaseline="middle"
                        transform={`rotate(${getTextPosition(index).rotation - 90}, ${getTextPosition(index).x}, ${getTextPosition(index).y})`}
                      >
                        {lines.map((line, i) => (
                          <tspan x={getTextPosition(index).x - getImageSize * 1} dy={i === 0 ? '0em' : '1.2em'} key={i}>
                            {line}
                          </tspan>
                        ))}
                      </text>
                    </g>
                  );
                })}
              </svg>
            </div>

            <div className={'spinCenteredImgContainerStyle'} style={{
              cursor: isSpinning ? "no-drop" : "pointer",
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10
            }}>
              <div className="spinPointerStyle" style={{ clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" }} />
              <div className={'spinCenteredImgDivStyle'} style={styleConfig?.wheelImageStyle}>
                {(wheelImage || questDetails?.sdkConfig?.uiProps?.wheelImage) ? (
                  <img src={wheelImage} alt="Mystic" className={'spinCenteredImgStyle'} />
                ) : (
                  <p className={'spinCenteredTextStyle'}>{spinCenteredText || questDetails?.sdkConfig?.uiProps?.spinCenteredText || 'Spin'}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {showCongratulations && (
          <div className={'spinSuccessModal'} style={styleConfig?.successModalStyle}>
            <h5 className={'spinH5Style'}>Congratulations</h5>
            <p className={'spinH2Style'}>You have won:</p>
            <div className="rewardImgContainer">
              <img
                src={rewardImage}
                alt="Reward"
                style={{ width: "60px", height: "60px", marginBottom: "0px" }}
              />
              {isSecondaryImage === true && rewardSecondaryImage && winningSegmentIndex !== null && Rewards[winningSegmentIndex].rewardType === 'REWARD_CUSTOM_REWARD' && (
                <img
                  src={rewardSecondaryImage}
                  alt="RewardSecondary"
                  style={{ width: "60px", height: "60px", marginBottom: "0px" }}
                />
              )}
            </div>
            {rewardValue && (
              <p style={{ textAlign: "center", marginLeft: "-6px" }}>
                {rewardValue}
              </p>
            )}
            <div
              style={styleConfig?.claimButtonStyle}
              className={'spinAmazingButtonStyle'}
              onClick={() => {
                setShowCongratulations(false);
                setWinningSegmentIndex(null);
                setIsText(true);
                if (successCall) {
                  successCall();
                }
              }}
            >
              <p>{claimButtonText || questDetails?.sdkConfig?.uiProps?.claimButtonText || 'Claim'}</p>
            </div>
          </div>
        )}
      </div> : isLoader && (loaderComponent || <Loader />)}
      {isLoaded && <p className="spinText" style={{ width: `${wheelSize + 12}px`, ...spinText?.style }}>
        {isText ? spinText?.text || questDetails?.sdkConfig?.uiProps?.spinText?.text || 'Tap the wheel to spin!' : ''}
      </p>}
    </>
  );
};

export default SpinTheWheel;
